export const DUOTONE_MIN_W = 20;
export const DUOTONE_MAX_W = 48;
